<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<mat-card
  class="moment-card"
  [ngClass]="{ inactive: !card.visible && isFolioSection }"
  [attr.aria-label]="'translations.global.ariaLabels.open' | transloco: { title: card?.title }"
  (keydown.enter)="openMomentForView()"
  (click)="openMomentForView()"
  tabindex="0"
  role="button"
  [style.cursor]="card.viewType === 'COLLECTOR' ? 'initial' : ''"
>
  <div class="moment-card__top">
    <div class="moment-card__top__icon-container-wrapper">
      <div class="moment-card__top-left-section">
        <ptl-profile-image [userSummary]="userDetailsData$ | async"></ptl-profile-image>
        <div class="moment-card__info">
          <div class="moment-card__profile-title">
            {{ (userDetailsData$ | async)?.firstName }}
          </div>
          <div class="moment-card__date">
            {{ card.createdAt | folioCardTimeAgo }}
          </div>
        </div>
      </div>
      <button
        *ngIf="card.viewType === 'COLLECTOR'"
        mat-icon-button
        class="moment-card__button"
        [title]="selected ? 'Remove' : 'Add'"
        [class.is_selected]="selected"
        (click)="onButtonClick(); $event.stopPropagation()"
      >
        <svg class="svg" role="img" [attr.aria-label]="'translations.global.ariaLabels.icons.plus' | transloco">
          <use ogSvgUnify="assets/sprite/sprite.svg#plus"></use>
        </svg>
      </button>

      <button
        *ngIf="isFolioSection && editMode"
        [attr.aria-label]="
          !card.visible
            ? ('translations.global.ariaLabels.changeItemVisibilityToPublic' | transloco: { name: card?.title })
            : ('translations.global.ariaLabels.changeItemVisibilityToPrivate' | transloco: { name: card?.title })
        "
        (click)="onItemVisibilityState(card, $event)"
        mat-icon-button
        class="visibility-icon"
      >
        <svg class="svg" role="img" *ngIf="!card.visible" [attr.aria-label]="'translations.global.ariaLabels.icons.openedEye' | transloco">
          <use ogSvgUnify="assets/sprite/sprite.svg#visibility-off"></use>
        </svg>
        <svg class="svg" role="img" *ngIf="card.visible" [attr.aria-label]="'translations.global.ariaLabels.icons.closedEye' | transloco">
          <use ogSvgUnify="assets/sprite/sprite.svg#visibility"></use>
        </svg>
      </button>
    </div>
  </div>

  <div class="moment-card__content">
    <ptl-resource-preview
      class="thin-preview"
      [previewContent]="card.content"
      [withTruncateLines]="true"
      [collage]="true"
    ></ptl-resource-preview>

    <ptl-v3-folio-masonry-card-tags [tags]="card?.tags"></ptl-v3-folio-masonry-card-tags>
  </div>
  <div class="moment-card-action-buttons">
    <button
      tabindex="0"
      mat-icon-button
      class="moment-action-btn"
      [attr.aria-label]="'translations.global.ariaLabels.commentItem' | transloco: { name: card?.title }"
      (click)="openCommentsDialog($event)"
    >
      <div class="content">
        <svg class="svg" aria-hidden="true">
          <use ogSvgUnify="assets/sprite/sprite.svg#comment"></use>
        </svg>
        <span class="count">{{ card?.commentsCount || 0 }}</span>
      </div>
    </button>
    <button
      tabindex="0"
      mat-icon-button
      class="moment-action-btn"
      [attr.aria-label]="'translations.global.ariaLabels.likeItem' | transloco: { name: card?.title }"
      (click)="onLikeMoment($event)"
    >
      <div class="content">
        <mat-icon [class.liked]="card?.likes?.liked" aria-hidden="true">
          {{ card?.likes?.liked ? 'favorite' : 'favorite_border' }}
        </mat-icon>
        <span class="count">{{ card?.likes?.totalLikes || 0 }}</span>
      </div>
    </button>
  </div>
</mat-card>
